import React from 'react'
import Stack from '@mui/material/Stack'
import { Layout } from 'app/layout/Layout'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import lazyWithReload from 'utils/lazy-with-reload'

const PortalSubContainer = lazyWithReload(/* webpackPrefetch: true */ () => import('./PortalSubContainer/PortalSubContainer'))
const GmsSubContainer = lazyWithReload(/* webpackPrefetch: true */ () => import('./GmsSubContainer'))

export const DashboardContainer: React.FC = () => {
  const isPortal = useIsPortal()
  return (
    <Layout>
      <Stack my={1}>{isPortal ? <PortalSubContainer /> : <GmsSubContainer />}</Stack>
    </Layout>
  )
}

export default DashboardContainer
